import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route, ERROR_TO_ONBOARDING_ROUTE } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { ErrorHandler, CheckoutErrorContext } from './types'
import { AU_REG_ERROR_CODES } from '../../model'
import { setIntegrationContext } from '../../state'

export const createCheckoutStartAURegulationErrorHandler = (): ErrorHandler => {
  return {
    canHandle: (errorCode: ErrorCode, error: PortalApiError): boolean => {
      return AU_REG_ERROR_CODES.includes(errorCode)
    },

    handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route | undefined> => {
      context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
        isRecoverableTerminalError: false,
        errorCode,
      })

      const onboardingRouteExists = typeof ERROR_TO_ONBOARDING_ROUTE[errorCode] !== 'undefined'
      const isEligibleForCreditFacilityIntroduction = error.errorInfo?.facility_application_eligibility === 'eligible'

      const onboardingRoute = ERROR_TO_ONBOARDING_ROUTE[errorCode]

      // Apple Retail: show the education intro (NUX) once per session for LCCC-pending customers
      // whose /start is rejected with UnsuitabilityNotFound or ContractAcceptanceRequired.
      //
      // UnsuitabilityNotFound (new customers): NUX → GET_STARTED ("Step 1 of 2") → unsuitability
      // questions. Net-new customers already saw the NUX pre-login; once hasSeenEducationIntro is
      // set we skip straight to GET_STARTED.
      //
      // ContractAcceptanceRequired (returning customers who didn't accept the LCCC contract):
      // NUX → CONTRACT_AGREEMENT (no GET_STARTED — they already completed step 1).
      if (context.isAppleRetailOrder && errorCode === ErrorCode.UnsuitabilityNotFound) {
        if (!context.hasSeenEducationIntro) {
          context.dispatch(setIntegrationContext({ nextRoute: Route.GET_STARTED }))
          return Route.EDUCATION_INTRO
        }
        return Route.GET_STARTED
      }

      if (context.isAppleRetailOrder && errorCode === ErrorCode.ContractAcceptanceRequired) {
        if (!context.hasSeenEducationIntro) {
          context.dispatch(setIntegrationContext({ nextRoute: onboardingRoute }))
          return Route.EDUCATION_INTRO
        }
        return onboardingRoute
      }

      if (onboardingRouteExists && isEligibleForCreditFacilityIntroduction && errorCode !== ErrorCode.ContractAcceptanceRequired) {
        return Route.GET_STARTED
      }

      return onboardingRoute
    },
  }
}
